// ui constants

export const TOGGLE_ITEM = 'TOGGLE_ITEM';
export const TOGGLE_TABS = 'TOGGLE_TABS';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';

// contact form

export const SET_FORM_DATA = 'SET_FORM_DATA';
export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SET_SUBMIT_SUCCESS = 'SET_SUBMIT_SUCCESS';
export const SET_SUBMIT_FAIL = 'SET_SUBMIT_FAIL';
export const SET_FORM_ERRORS = 'SET_FORM_ERRORS';
export const SET_FORM_LOADING = 'SET_FORM_LOADING';

// legal entities
export const FETCH_LEGAL_ENTITIES = 'FETCH_LEGAL_ENTITIES';
export const FETCH_LEGAL_ENTITIES_SUCCESS = 'FETCH_LEGAL_ENTITIES_SUCCESS';
export const FETCH_LEGAL_ENTITIES_FAILURE = 'FETCH_LEGAL_ENTITIES_FAILURE';

// market content
export const SET_MARKET_CONTENT = 'SET_MARKET_CONTENT';
